import './ThirdPartyFrame.scss';

import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { Spinner } from "@trp-beacon-ui-kit/react-communication";

const ThirdPartyFrame = ({
  classNameOverride,
  name,
  src,
  scrolling = 'auto',
  containerURL,
  message,
  params = {},
  errorUrl,
  eligible
}) => {
  const [fatalError, setFatalError] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [scrollValue, setScrollValue] = useState(0)

  if(window) {
    window.onscroll = () => {
      if(document && document.documentElement && scrollValue === 0) {
        if(document.documentElement.scrollTop > 100){
          setScrollValue(document.documentElement.scrollTop)
        }
      }
    }
  }

  useEffect(() => {
    if (!isEmpty(message)) {
      setLoaded(true);
    }
  }, [message]);

  useEffect(() => {
    if(scrollValue !== 0) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }, [scrollValue]);

  useEffect(() => {
    if (loaded) {
      const authForm = document.getElementById('auth-form');
      try {
        authForm.submit();
      } catch(e){
        setFatalError(true);
      }
    }
  }, [loaded]);

  if (!eligible) {
    setFatalError(true);
  }
  if (fatalError) {
    window.location.replace(errorUrl);
  }

  return (
    <div>
      {loaded &&
      <form id="auth-form" method="POST" action={containerURL} target={name}>
        <input type={'hidden'} name={'SAMLResponse'} value={message} />
        {Object.entries(params).map((entry, i) => {
          return (
            <input
              key={'param' + i}
              type="hidden"
              name={entry[0]}
              value={entry[1]}
            />
          );
        })}
      </form>
      }
      <div className={`third-party-frame-boundary ${classNameOverride}`}>
        {!loaded && (
          <div className={'progress-bar-container blocked_data'}>
            <div className={'progress-loader'}>
              <div className="spinner-wrapper">
                <div className={'tag-line'}>Collecting Your Investment Information...</div>
                <Spinner/>
              </div>
            </div>
          </div>
        )}
        {!src && (
          <iframe
            className={'third-party-frame blocked_data'}
            id={name}
            name={name}
            frameBorder={0} // change to border on styles of third-party-frame
            sandbox={'allow-same-origin allow-forms allow-scripts allow-popups allow-modals allow-downloads'}
            scrolling={scrolling}
            loading={'eager'}
          />
        )}
        {src && (
          <iframe
            id={name}
            className={'third-party-frame blocked_data'}
            src={src}
            name={name}
            frameBorder={0} // change to border on styles of third-party-frame
            sandbox={'allow-same-origin allow-forms allow-scripts allow-popups allow-modals allow downloads'}
            scrolling={scrolling}
            loading={'eager'}
          />
        )}
      </div>
    </div>
  );
};

export default ThirdPartyFrame;
